/**
 * Hash that will match the "state=stuff" (including the stuff) and the preceding ? or # token
 * because MSAL seems to pick randomly whether it wants to use hash or query params.
 */
export const stateInHashReplacer = /(#|\?)state=(\w+)(&|\?|)/gi;
